import { createFileRoute } from '@tanstack/react-router'
import { useParams } from '@tanstack/react-router'
import PlotForm from '@/components/rx/PlotForm';

export const Route = createFileRoute(
  '/dashboard/fields/$fieldId/rx/$rxId/plots/draw',
)({
  component: RouteComponent,
})

function RouteComponent() {
    const { fieldId, rxId } = useParams({
      from: '/dashboard/fields/$fieldId/rx/$rxId/plots/draw',
    });

    return (
        <PlotForm
            fieldId={fieldId}
            rxId={rxId}
            placement="manual"
        />
    )
}
